import { gql } from '@apollo/client';

export const RESERVATION_MUTATION = gql`
  mutation Reservation($input: AddExternalReservationInput!) {
    externalAddReservation(input: $input) {
      success
    }
  }
`;

export const VALUATION_MUTATION = gql`
  mutation Valuation($input: LeadInput!) {
    lead(input: $input) {
      valuation {
        success
      }
    }
  }
`;

export const SAMTYKKER_MUTATION = gql`
  mutation RegistrerBrukerSamtykke($input: BrukerSamtykker!) {
    registrerBrukerSamtykke(input: $input) {
      success
    }
  }
`;
